"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJsonObject = void 0;
const isJsonValue_1 = require("./isJsonValue");
function isJsonObject(value) {
    if (value === null) {
        return false;
    }
    if (typeof value !== "object") {
        return false;
    }
    if (value.constructor !== {}.constructor) {
        return false;
    }
    for (const [k, v] of Object.entries(value)) {
        if (typeof k !== "string") {
            return false;
        }
        if (!(0, isJsonValue_1.isJsonValue)(v)) {
            return false;
        }
    }
    return true;
}
exports.isJsonObject = isJsonObject;
//# sourceMappingURL=isJsonObject.js.map